import { Paper, Typography, Grid, IconButton, Button, Select, Checkbox, MenuItem, TextField } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import skillsData from '../data/skills.json'
import forcePowersData from '../data/forcePowers.json'
import { SvgIcon } from '@mui/material';
import { blankTalentRows } from '../Util/BlankItems';

const appFiles = JSON.parse(localStorage.getItem('appFiles') || '{}');
let skills = skillsData
if (appFiles.skills) { skills = JSON.parse(appFiles.skills) }
let forcePowers = forcePowersData
if (appFiles.forcePowers) { forcePowers = JSON.parse(appFiles.forcePowers) }

const LeftRightIcon = ({ checked }) => (
    <SvgIcon
        viewBox="0 0 100 20"
        sx={{ width: "100px", height: "20px" }} >
        <rect width="100" height="20" fill={checked ? "green" : "gray"} />
    </SvgIcon>
);

const UpDownIcon = ({ checked }) => (
    <SvgIcon
        viewBox="0 0 20 50"
        sx={{ width: "20px", height: "50px" }}
    >
        <rect width="20" height="50" fill={checked ? "green" : "gray"} />
    </SvgIcon>
);


const SpecEdit = ({ editedItem, index, appFiles, setAppFiles }) => {

    const talents = JSON.parse(appFiles.talents)
    const specSkills = editedItem.CareerSkills || []

    const handleEdit = (newItem) => {
        let newFiles = { ...appFiles };
        let newCat = JSON.parse(appFiles["specializations"]);
        newCat[index] = newItem;
        newFiles["specializations"] = JSON.stringify(newCat);
        setAppFiles(newFiles);
        localStorage.setItem('appFiles', JSON.stringify(newFiles));
    };

    return (
        <Paper>
            <>
                <Typography>Career Skills:</Typography>
                <Grid container>
                    {specSkills.map((cSkill, index) => (
                        <Grid item key={index} sx={{ margin: "7.5px" }}>
                            <Select
                                value={cSkill || ''}
                                onChange={(e) => {
                                    let newSkills = [...specSkills];
                                    newSkills[index] = e.target.value;
                                    handleEdit({ ...editedItem, CareerSkills: newSkills });
                                }}
                                sx={{ minWidth: "80px" }}
                            >
                                {skills.sort((a, b) => (a.skill || "").localeCompare(b.skill || "")).map((skill) => (
                                    <MenuItem key={skill.Key} value={skill.skill}>
                                        {skill.skill}
                                    </MenuItem>
                                ))}
                            </Select>
                            <IconButton onClick={(e) => {
                                let newCareerSkills = [...specSkills];
                                newCareerSkills.splice(index, 1)
                                handleEdit({ ...editedItem, CareerSkills: newCareerSkills });
                            }}
                                sx={{ maxWidth: "30px" }}
                                size="small"
                                className="no-print"
                            >
                                <CloseIcon />
                            </IconButton>
                        </Grid>
                    ))}
                </Grid>
                <Button onClick={(e) => {
                    let newCareerSkills = [...specSkills];
                    newCareerSkills.push("")
                    handleEdit({ ...editedItem, CareerSkills: newCareerSkills });
                }}
                    className="no-print"
                >
                    Add
                </Button>
            </>
            <Typography>Chosen Career Skills:</Typography>
            <Grid container alignItems="center" spacing={1} sx={{ margin: "0 0 7.5px 0" }}>
                <Grid item>
                    <TextField
                        label="Count"
                        size="small"
                        sx={{ maxWidth: "90px" }}
                        value={editedItem.AddlCareerSkills?.SkillCount || ""}
                        onChange={(e) => {
                            const val = e.target.value.trim()
                            if (val !== "" && !/^\d+$/.test(val)) { return }
                            let addl = { ...editedItem.AddlCareerSkills }
                            if (val && parseInt(val) > 0) {
                                addl.SkillCount = val
                                if (addl.Type === undefined) { addl.Type = "" }
                            } else {
                                addl = { Type: "" }
                            }
                            handleEdit({ ...editedItem, AddlCareerSkills: addl })
                        }}
                    />
                </Grid>
                <Grid item>
                    <Select
                        size="small"
                        displayEmpty
                        disabled={!editedItem.AddlCareerSkills?.SkillCount}
                        value={editedItem.AddlCareerSkills?.Type || ""}
                        onChange={(e) => {
                            const addl = { ...editedItem.AddlCareerSkills, Type: e.target.value }
                            delete addl.TypeValue
                            handleEdit({ ...editedItem, AddlCareerSkills: addl })
                        }}
                        sx={{ minWidth: "150px" }}
                    >
                        <MenuItem value="">Any Category</MenuItem>
                        {[...new Set(skills.map((s) => s.type).filter(Boolean))].sort().map((type) => (
                            <MenuItem key={type} value={type}>{type}</MenuItem>
                        ))}
                    </Select>
                </Grid>
            </Grid>
            {!editedItem.TalentRows && (
                <Button className="no-print" onClick={() => handleEdit({ ...editedItem, TalentRows: blankTalentRows() })}>
                    Create Talent Grid
                </Button>
            )}
            {editedItem.TalentRows && (
                <>
                    <Typography>Talent Grid:</Typography>
                    {editedItem.TalentRows.map((row, index) => (
                        <Grid container key={index} spacing={2}>
                            {row.Talents.map((talent, i) => (
                                <Grid item xs={3} key={i}>
                                    <Grid container>
                                        <Grid
                                            item
                                            xs={4}
                                            sx={{
                                                position: "relative",
                                                paddingTop: "10px",
                                            }}
                                        >
                                            {i > 0 && (<Checkbox
                                                checked={!!(row.Directions[i].Left && row.Directions[i - 1].Right)}
                                                onChange={(e) => {
                                                    let newRows = [...editedItem.TalentRows];
                                                    newRows[index].Directions[i].Left = e.target.checked;
                                                    newRows[index].Directions[i - 1].Right = e.target.checked;
                                                    handleEdit({ ...editedItem, TalentRows: newRows });
                                                }}
                                                icon={<LeftRightIcon />}
                                                checkedIcon={<LeftRightIcon checked />}
                                                sx={{
                                                    position: "absolute",
                                                    left: "18px",
                                                }}
                                            />
                                            )}
                                        </Grid>
                                        <Grid item xs={8}>
                                            <Grid container direction="column" alignItems="center">
                                                <Grid item>
                                                    <Select
                                                        value={talent}
                                                        onChange={(e) => {
                                                            let newRows = [...editedItem.TalentRows];
                                                            let newRow = { ...row };
                                                            let newTalents = newRow.Talents;
                                                            newTalents[i] = e.target.value;
                                                            newRow.Talents = newTalents;
                                                            newRows[index] = newRow;
                                                            handleEdit({ ...editedItem, TalentRows: newRows });
                                                        }}
                                                        sx={{ background: "black", zIndex: 50, minWidth: "300px" }}
                                                    >
                                                        {talents
                                                            .sort((a, b) => a.Name.localeCompare(b.Name))
                                                            .map((talent) => (
                                                                <MenuItem key={talent.Key} value={talent.Key}>
                                                                    {talent.Name}
                                                                </MenuItem>
                                                            ))}
                                                    </Select>
                                                </Grid>
                                                {index < editedItem.TalentRows.length - 1 && (
                                                    <Grid item>
                                                        <Checkbox
                                                            checked={!!(row.Directions[i].Down && editedItem.TalentRows[index + 1].Directions[i].Up)}
                                                            onChange={(e) => {
                                                                let newRows = [...editedItem.TalentRows];
                                                                newRows[index].Directions[i].Down = e.target.checked;
                                                                newRows[index + 1].Directions[i].Up = e.target.checked;
                                                                handleEdit({ ...editedItem, TalentRows: newRows });
                                                            }}
                                                            icon={<UpDownIcon />}
                                                            checkedIcon={<UpDownIcon checked />}
                                                        />
                                                    </Grid>
                                                )}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            ))}
                        </Grid>
                    ))}
                </>
            )}
            <br />
            <Typography>Is Universal:</Typography>
            <Checkbox
                checked={editedItem.Universal !== undefined && editedItem.Universal !== false}
                onChange={(e) => {
                    handleEdit({ ...editedItem, Universal: e.target.checked })
                }}
            />
            <Typography>Grants Force Rating:</Typography>
            <Checkbox
                checked={!!editedItem.Attributes?.ForceRating}
                onChange={(e) => {
                    let newAttributes = { ...editedItem.Attributes }
                    if (e.target.checked) {
                        newAttributes.ForceRating = 1
                    } else {
                        delete newAttributes.ForceRating
                    }
                    handleEdit({ ...editedItem, Attributes: newAttributes })
                }}
            />
            <Typography>Minimum Force Rating:</Typography>
            <TextField
                sx={{ maxWidth: "120px" }}
                value={editedItem.Attributes?.Requirement?.MinForceRating || ""}
                onChange={(e) => {
                    const val = e.target.value.trim()
                    if (val !== "" && !/^\d+$/.test(val)) { return }
                    let newAttributes = { ...editedItem.Attributes }
                    let newRequirement = { ...newAttributes.Requirement }
                    if (val && parseInt(val) > 0) {
                        newRequirement.MinForceRating = val
                    } else {
                        delete newRequirement.MinForceRating
                    }
                    if (Object.keys(newRequirement).length) {
                        newAttributes.Requirement = newRequirement
                    } else {
                        delete newAttributes.Requirement
                    }
                    handleEdit({ ...editedItem, Attributes: newAttributes })
                }}
            />

            <br />
            {(() => {
                const cp = editedItem.CareerPowers;
                const cpMode = cp === 'ANY_1' ? 'ANY_1'
                    : cp === 'ANY_2' ? 'ANY_2'
                        : Array.isArray(cp) ? 'SPECIFIC' : 'NONE';
                const cpArray = Array.isArray(cp) ? cp : [];

                const setCpMode = (mode) => {
                    if (mode === 'NONE') {
                        let ni = { ...editedItem };
                        delete ni.CareerPowers;
                        handleEdit(ni);
                    } else if (mode === 'SPECIFIC') {
                        handleEdit({ ...editedItem, CareerPowers: cpArray.length ? cpArray : [] });
                    } else {
                        handleEdit({ ...editedItem, CareerPowers: mode });
                    }
                };

                const setCpPower = (slot, val) => {
                    let arr = [cpArray[0] || '', cpArray[1] || ''];
                    arr[slot] = val;
                    handleEdit({ ...editedItem, CareerPowers: arr.filter((k) => k) });
                };

                const powerMenu = forcePowers
                    .slice()
                    .sort((a, b) => a.Name.localeCompare(b.Name))
                    .map((p) => (
                        <MenuItem key={p.Key} value={p.Key}>{p.Name}</MenuItem>
                    ));

                return (
                    <>
                        <Typography>Career Powers (reSpecialized grants):</Typography>
                        <Select
                            value={cpMode}
                            onChange={(e) => setCpMode(e.target.value)}
                            sx={{ minWidth: "200px" }}
                        >
                            <MenuItem value="NONE">None</MenuItem>
                            <MenuItem value="ANY_1">Any 1 power</MenuItem>
                            <MenuItem value="ANY_2">Any 2 powers</MenuItem>
                            <MenuItem value="SPECIFIC">Specific powers</MenuItem>
                        </Select>
                        {cpMode === 'SPECIFIC' && (
                            <Grid container sx={{ marginTop: "7.5px" }}>
                                <Grid item sx={{ margin: "7.5px" }}>
                                    <Select
                                        value={cpArray[0] || ''}
                                        onChange={(e) => setCpPower(0, e.target.value)}
                                        sx={{ minWidth: "160px" }}
                                        displayEmpty
                                    >
                                        <MenuItem value="">(none)</MenuItem>
                                        {powerMenu}
                                    </Select>
                                </Grid>
                                <Grid item sx={{ margin: "7.5px" }}>
                                    <Select
                                        value={cpArray[1] || ''}
                                        onChange={(e) => setCpPower(1, e.target.value)}
                                        sx={{ minWidth: "160px" }}
                                        displayEmpty
                                    >
                                        <MenuItem value="">(none)</MenuItem>
                                        {powerMenu}
                                    </Select>
                                </Grid>
                            </Grid>
                        )}
                    </>
                );
            })()}

        </Paper>
    )
}

export default SpecEdit